import { z } from 'zod'
import './registry'

export const IdentifyRequestSchema = z
  .object({
    imageKey: z.string().min(1).max(512),
  })
  .openapi('IdentifyRequest')

/**
 * Claude Vision returns these label fields when it can. Each is optional —
 * empty strings on the wire are coerced to null here.
 */
export const IdentifyResponseSchema = z
  .object({
    artist: z.string().nullable(),
    album: z.string().nullable(),
    year: z.string().nullable(),
    catalogue: z.string().nullable(),
    /**
     * Alternative readings of the catalogue number the model judged plausible,
     * most-likely-first and EXCLUDING `catalogue` itself. The catno is the
     * noisiest OCR field yet it selects the *pressing* (and thus price + which
     * physical record ships), so we keep the runners-up to feed the Discogs
     * matcher (lib/catno-match.ts) rather than betting on a single reading.
     * Empty when the model was confident or no number was legible.
     */
    catalogueCandidates: z.array(z.string()),
    country: z.string().nullable(),
    label: z.string().nullable(),
    genre: z.string().nullable(),
  })
  .openapi('IdentifyResponse')

export type IdentifyRequest = z.infer<typeof IdentifyRequestSchema>
export type IdentifyResponse = z.infer<typeof IdentifyResponseSchema>
